import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { UmkreissucheQuerySorterConfig } from 'fa-kt.types';
import { UmkreissucheService } from '../service';

@Component({
  selector: 'fa-kt-umkreissuche-sorter',
  templateUrl: './umkreissuche-sorter.component.html',
  styleUrls: ['./umkreissuche-sorter.component.css'],
})
export class UmkreissucheSorterComponent {
  public UmkreissucheSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public umkreissuche: UmkreissucheService,
  ) {
    this.UmkreissucheSorterConfig = UmkreissucheQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
